module.exports = __webpack_public_path__ + "static/media/mob_alert_partner_platinum_x2.60759d9f.png";